<template lang="pug">
.c-cms-advisors
  staffs-editor(title="顧問團"
    id="advisors")
</template>

<script>
import StaffsEditor from "@/components/cms/StaffsEditor.vue";

export default {
  name: "CmsAdvisors",
  components: {
    StaffsEditor
  }
};
</script>
